import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';

import GalleryIcon from '@/assets/all-icons/gallery-icon';
import config from "@/config";
import useGetSearchParams from "@/hooks/useGetSearchParams";
import useQuery from "@/hooks/useQuery";
import HomeHeader from '@/shared-components/home/components/HomeHeader';
import Loader from "@/shared-components/loader/Loader";
import Text from "@/shared-components/text/components/Text";
import AppNavigationPage from '@/shared-components/wrappers/components/AppNavigationPage';

import VirtualList from "./components/VirtualList";

import './index.css';

export default function HomeGalleries({ fromSearch = false, valueFromSearch = "" }) {
  const [params, setParams] = useGetSearchParams();
  const [query, setQuery] = useState(params ? params : { q: "" });
  const { loading, queryData, loadMoreData } = useQuery(
    "home_galleries", 
    `${config.apis.api.url}/search/gallery`, 
    query, 
    { injectToken: true }
  );

  function onInput(value) {
    const newQuery = { q: value };
    setQuery(newQuery);
    setParams(newQuery, { replace: true });
  }

  useEffect(() => {
    onInput(valueFromSearch.q);
  }, [valueFromSearch.q]);

  return (
    <>
      { !fromSearch &&
        <>
          <Helmet>
            <title>Galleries | Suarte</title>
            <meta
              name="description"
              content="Buy now with ease and showcase original paintings and wall sculptures from the world's best galleries. Follow gallery profiles and be part of the global art community."
            />
            <link rel="canonical" href={"https://suarte.art/galleries"} />
          </Helmet>

          <AppNavigationPage>
            <div className="home-galleries__page">
              <HomeHeader 
                onInput={onInput} 
                value={query.q} 
                icon={<GalleryIcon className="home-galleries__header-icon"/>} 
                text="Galleries" 
                placeholder="Search for galleries..."
              />

              {loading ? (
                <Loader />
              ) : queryData.data.data.length === 0 ? (
                <Text className="home-galleries__empty-text" paragraph medium>
              No galleries available for your search query.
                </Text>
              ) : (
                <VirtualList 
                  key={queryData.queryString} 
                  items={queryData.data} 
                  onLoadMore={loadMoreData}
                />
              )}
            </div>
          </AppNavigationPage>
        </>
      }
      { fromSearch &&
        <>
          {
            loading ? 
              <Loader />
              : queryData.data.data.length === 0 ?
                <Text className="home-galleries__empty-text" paragraph medium>
                  No galleries available for your search query.
                </Text>
                :
                <VirtualList 
                  key={queryData.queryString} 
                  items={queryData.data} 
                  onLoadMore={loadMoreData}
                  fromSearch={fromSearch}
                />
          }
        </>
      }
    </>
  );
}
